import { GET_ALL_TYPEFIELD ,ADD_FIELD_TYPE} from '../types'

const INITIAL_STATE = {
  allTypeFields: [],
  addFieldType:[],
}

const fieldTypeReducer = (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {
    case GET_ALL_TYPEFIELD:
      return {
        ...state,
        allTypeFields: payload.data,
      }
      case ADD_FIELD_TYPE:
        return {
          ...state,
          addFieldType: payload.data,
        }

    default:
      return state
  }
}

export default fieldTypeReducer
